/**
 * @generated SignedSource<<b4a4cdf459c5c471f8a624ef1e20cd54>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type NewsTickerDefinitionOverviewScreen_PaginationFragmentRefetch$variables = {
  after?: string | null | undefined;
  first: number;
};
export type NewsTickerDefinitionOverviewScreen_PaginationFragmentRefetch$data = {
  readonly " $fragmentSpreads": FragmentRefs<"NewsTickerDefinitionOverviewScreen_PaginationFragment">;
};
export type NewsTickerDefinitionOverviewScreen_PaginationFragmentRefetch = {
  response: NewsTickerDefinitionOverviewScreen_PaginationFragmentRefetch$data;
  variables: NewsTickerDefinitionOverviewScreen_PaginationFragmentRefetch$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "after"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "first"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "NewsTickerDefinitionOverviewScreen_PaginationFragmentRefetch",
    "selections": [
      {
        "args": (v1/*: any*/),
        "kind": "FragmentSpread",
        "name": "NewsTickerDefinitionOverviewScreen_PaginationFragment"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "NewsTickerDefinitionOverviewScreen_PaginationFragmentRefetch",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AdminQueryType",
        "kind": "LinkedField",
        "name": "Admin",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "NewstickerAdminSchema",
            "kind": "LinkedField",
            "name": "Newsticker",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v1/*: any*/),
                "concreteType": "NewstickerMessagesConnection",
                "kind": "LinkedField",
                "name": "NewstickerMessages",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "NewstickerMessagesEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "NewstickerMessage",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "id",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "text",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "forwardingUrl",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "isActive",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "__typename",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "cursor",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "endCursor",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hasNextPage",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "kind": "ClientExtension",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "__id",
                        "storageKey": null
                      }
                    ]
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v1/*: any*/),
                "filters": null,
                "handle": "connection",
                "key": "NewsTickerDefinitionOverviewScreen_NewstickerMessages",
                "kind": "LinkedHandle",
                "name": "NewstickerMessages"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "5b9ef6a8cd135c998d774f4a12c3c6c5",
    "id": null,
    "metadata": {},
    "name": "NewsTickerDefinitionOverviewScreen_PaginationFragmentRefetch",
    "operationKind": "query",
    "text": "query NewsTickerDefinitionOverviewScreen_PaginationFragmentRefetch(\n  $after: String\n  $first: Int!\n) {\n  ...NewsTickerDefinitionOverviewScreen_PaginationFragment_2HEEH6\n}\n\nfragment NewsTickerDefinitionOverviewScreen_PaginationFragment_2HEEH6 on Query {\n  Admin {\n    Newsticker {\n      NewstickerMessages(first: $first, after: $after) {\n        edges {\n          node {\n            id\n            text\n            forwardingUrl\n            isActive\n            __typename\n          }\n          cursor\n        }\n        pageInfo {\n          endCursor\n          hasNextPage\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "58285c6d94fdf4bc556616569ca2e3e3";

export default node;
